import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
	selector: '[appNavToggle]'
})
export class NavToggleDirective {
	constructor() {


	}

	@HostListener('click') onClick() {
		this.isActive = !this.isActive;
	}

	@HostBinding('class.show') isActive = false;


}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/shared/directives/nav-toggle/nav-toggle.directive.ts